var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'id-card-input': true,
    'id-card-input--mm': _vm.isMMIdCardType
  }},[(_vm.isMMIdCardType)?[_c('el-cascader',{attrs:{"value":_vm.mmIDValue.pickData,"disabled":_vm.disabled,"options":_vm.options,"props":{ expandTrigger: 'hover' },"filterable":"","filter-method":_vm.onFilter},on:{"input":_vm.onIdCardInput}}),_c('el-input',{attrs:{"value":_vm.mmIDValue.extraCode,"disabled":_vm.disabled,"maxlength":"6"},on:{"input":_vm.onIdCardNumberInput}})]:_c('el-input',{attrs:{"value":_vm.value,"disabled":_vm.disabled,"maxlength":"30"},on:{"input":_vm.onInput}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }